import CityPageSEO from "@/hooks/usePageSEO";
import MilledgevilleHeroSection from "./components/HeroSection";
import MilledgevilleStickyNav from "./components/StickyNav";
import MilledgevilleProcessingTimeSection from "./components/ProcessingTimeSection";
import MilledgevilleServicesSection from "./components/ServicesSection";
import MilledgevilleHowItWorksSection from "./components/HowItWorksSection";
import MilledgevilleLocalAreaSection from "./components/LocalAreaSection";
import MilledgevilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MilledgevilleComparisonSection from "./components/ComparisonSection";
import MilledgevilleMistakesSection from "./components/MistakesSection";
import MilledgevilleTestimonialsSection from "./components/TestimonialsSection";
import MilledgevilleFAQSection, { faqs } from "./components/FAQSection";
import MilledgevilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MilledgevilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function MilledgevillePage() {
  return (
    <div className="min-h-screen bg-white">
      <CityPageSEO config={{
        cityName: "Milledgeville",
        route: "/cities/milledgeville",
        description: "Emergency and expedited passport services in Milledgeville, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Baldwin County and central Georgia travelers. Get your emergency passport fast!",
        geoPlacename: "Milledgeville, Georgia",
        geoPosition: "33.0801;-83.2321",
        keywords: "expedited passport, emergency passport, Milledgeville passport, same day passport Milledgeville, fast passport Georgia, Baldwin County passport",
        faqs,
      }} />
      <MilledgevilleHeroSection />
      <MilledgevilleStickyNav />
      <MilledgevilleProcessingTimeSection />
      <MilledgevilleServicesSection />
      <MilledgevilleHowItWorksSection />
      <MilledgevilleLocalAreaSection />
      <MilledgevilleAcceptanceFacilitiesSection />
      <MilledgevilleComparisonSection />
      <MilledgevilleMistakesSection />
      <MilledgevilleTestimonialsSection />
      <MilledgevilleFAQSection />
      <MilledgevilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/milledgeville" state="GA" />
      <MilledgevilleFinalCTA />
    </div>
  );
}